import { useState } from 'react';

import { Button } from '@/components/core/Button';
import { Dialog, DialogBody, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogHeaderDefault } from '@/components/core/Dialog';
import { Input } from '@/components/core/Input';
import { useTranslation } from '@/hooks/useTranslation';

interface ProvideLinkDialogProps {
    onApply: (value: string) => void;
    onClose: () => void;
}

const ProvideLinkDialog = ({ onApply, onClose }: ProvideLinkDialogProps) => {

    const [link, setLink] = useState<string | undefined>();
    const { t } = useTranslation();

    return (
        <Dialog onOpenChange={onClose} open={true}>
            <DialogContent variant="small" useReactPortal={true}>
                <DialogHeader>
                    <DialogHeaderDefault>{t('UPLOAD.PROVIDE_LINK')}</DialogHeaderDefault>
                </DialogHeader>
                <DialogBody className="tw-flex tw-flex-row tw-space-x-2 tw-items-center">
                    <span>{t('UPLOAD.LINK')}</span>
                    <Input value={link} onChange={e => setLink(e.target.value)} />
                </DialogBody>
                <DialogFooter>
                    <Button variant="default" type="button" disabled={!link} onClick={() => {
                        onApply(link as string);
                        onClose();
                    }}>
                        {t('APPLY_CHANGES')}
                    </Button>
                    <DialogClose asChild={true}>
                        <Button variant="secondary" type="submit">{t('CANCEL')}</Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );

};

export { ProvideLinkDialog };
